import { Empty, Typography } from "antd";
import FolderCard from "./FolderCard";
import FileCard from "./FileCard";

const GridView = ({
  selectedFolder,
  folderList,
  onFolderSelect,
  files,
  user_id,
  setSelectedRecord,
}) => {
  return (
    <div>
      {!selectedFolder && (
        <>
          <Typography.Title
            level={5}
            type="secondary"
            className="fm-root-label"
          >
            Folders
          </Typography.Title>

          {folderList?.length ? (
            <div className="fm-grid">
              {folderList.map((folder) => (
                <FolderCard
                  key={folder.id}
                  folder={folder}
                  onFolderSelect={onFolderSelect}
                  setSelectedRecord={setSelectedRecord}
                  user_id={user_id}
                />
              ))}
            </div>
          ) : (
            <Empty description={"Folders Not found"} />
          )}
        </>
      )}

      <>
        <Typography.Title level={5} type="secondary" className="fm-root-label">
          Workbooks
        </Typography.Title>
        {files?.length ? (
          <div className="fm-grid">
            {files.map((file) => (
              <FileCard
                key={file.id}
                file={file}
                user_id={user_id}
                setSelectedRecord={setSelectedRecord}
              />
            ))}
          </div>
        ) : (
          <Empty description={"Workbooks Not found"} />
        )}
      </>
    </div>
  );
};

export default GridView;
